import React, { useContext } from "react";
import { Card, Collapsible, Caption, Layout, TextStyle, TextField } from "@shopify/polaris";

// import hoc
import { withErrorBoundary, withFeature } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

const FinishDescription = () => {
  const { CHARACTER_COUNT, DEFAULT_FINISH_DESCRIPTION } = constant;
  const { setOnboarding, onboarding, setIsSubmitEnable, finishDescription } = useContext(BrandingContext);
  const { cms = () => {}, currentUser } = useContext(PrivateContext);
  const { brand } = currentUser || {};
  const { finish, updatedAt: brandUpdatedAt = "" } = brand || {};
  const { description: finishDesc } = finish || {};
  const { updatedAt = "" } = finishDesc || {};

  const onChangeAction = (value) => {
    if (value && value.slice(0, CHARACTER_COUNT)) {
      setOnboarding({ ...onboarding, finishDescription: value.slice(0, CHARACTER_COUNT) });
      setIsSubmitEnable(true);
    }
    if (!value) {
      setOnboarding({ ...onboarding, finishDescription: "" });
      setIsSubmitEnable(true);
    }
  };

  return (
    <Collapsible open>
      <Layout.AnnotatedSection
        title={cms("section.finishDescription.title")}
        description={cms("section.finishDescription.description")}
      >
        <Card
          title={[
            cms("section.finishDescription.card.title"),
            updatedAt ? (
              <TextStyle variation="subdued">
                <Caption>{`${baseHelper.lastUpdateDate(updatedAt)}`}</Caption>
              </TextStyle>
            ) : (
              <TextStyle variation="subdued">
                <Caption>{`${baseHelper.lastUpdateDate(brandUpdatedAt)}`}</Caption>
              </TextStyle>
            ),
          ]}
          actions={
            finishDescription !== DEFAULT_FINISH_DESCRIPTION && [
              {
                content: cms("label.reset"),
                onAction: () => [
                  setOnboarding({ ...onboarding, finishDescription: DEFAULT_FINISH_DESCRIPTION }),
                  setIsSubmitEnable(true),
                ],
              },
            ]
          }
        >
          <Card.Section>
            <TextField value={finishDescription} onChange={(value) => onChangeAction(value)} multiline={4} />
            <br />
            <TextStyle variation="subdued">
              {`${CHARACTER_COUNT - finishDescription.length} / ${CHARACTER_COUNT}`}
            </TextStyle>
          </Card.Section>
        </Card>
      </Layout.AnnotatedSection>
    </Collapsible>
  );
};

export default withFeature(withErrorBoundary(FinishDescription), {
  feature: constant.STANDARD_BRANDING,
});
